import { render } from "./order-to-release-leadtime.vue?vue&type=template&id=53ccc612"
import script from "./order-to-release-leadtime.vue?vue&type=script&lang=js"
export * from "./order-to-release-leadtime.vue?vue&type=script&lang=js"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__